import { z } from 'zod';
export const CATEGORIES = [
    'ANTIPASTO',
    'PRIMO',
    'SECONDO',
    'CONTORNO',
    'PIATTO UNICO',
    'DOLCE',
];
export const CategorySchema = z.enum(CATEGORIES);
export const IngredientSchema = z.object({
    id: z.string().optional(),
    name: z.string().trim().min(1, 'nome ingrediente richiesto').max(120),
    quantity: z.number().nonnegative().max(100000),
    unit: z.string().trim().max(20).nullable().optional(),
    order: z.number().int().nonnegative().default(0),
});
export const StepSchema = z.object({
    id: z.string().optional(),
    order: z.number().int().nonnegative(),
    content: z.string().trim().min(1).max(5000),
});
export const TagSchema = z.object({
    id: z.string().optional(),
    name: z.string().trim().min(1).max(40),
});
export const RecipeInputSchema = z.object({
    name: z.string().trim().min(1, 'nome ricetta richiesto').max(200),
    baseServings: z.number().int().min(1).max(50).default(2),
    prepTime: z.number().int().nonnegative().max(10000).nullable().optional(),
    notes: z.string().trim().max(5000).nullable().optional(),
    icon: z.string().trim().max(10).nullable().optional(),
    category: CategorySchema.nullable().optional(),
    ingredients: z.array(IngredientSchema).min(1, 'almeno un ingrediente richiesto'),
    steps: z.array(StepSchema).default([]),
    tags: z.array(z.string().trim().min(1).max(40)).default([]),
});
export const RecipeUpdateSchema = RecipeInputSchema.partial();
export const RecipeSchema = RecipeInputSchema.extend({
    id: z.string(),
    coverImage: z.string().nullable().optional(),
    createdAt: z.string(),
    updatedAt: z.string(),
});
export const RecipeListQuerySchema = z.object({
    search: z.string().trim().max(200).optional(),
    tag: z.string().trim().max(40).optional(),
    category: CategorySchema.optional(),
});
//# sourceMappingURL=recipe.js.map